const mapOptional = <T>(value: T | undefined | null): T | undefined => {
    return value ?? undefined;
};

export const ValueHelpers = {
    mapOptional,
};
